import PropTypes from "prop-types";

const CardDetail = ({ title, value, customClassName, isModal }) => (
  <div className={`${!isModal ? "tw-flex tw-gap-[8px]" : "tw-grid"} tw-items-baseline  ${customClassName}`}>
    <span className="tw-text-12 tw-font-semibold">
      {title}
      {!isModal ? ":" : ""}
    </span>
    {value && (
      <span className="tw-text-12 tw-max-h-[200px] tw-whitespace-pre-wrap tw-break-words tw-overflow-y-auto tw-overflow-x-hidden">
        {value}
      </span>
    )}
  </div>
);

CardDetail.propTypes = {
  customClassName: PropTypes.string,
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  isModal: PropTypes.bool,
};
CardDetail.defaultProps = {
  customClassName: null,
  isModal: false,
};
export default CardDetail;
